const audioContext = new (window.AudioContext || window.webkitAudioContext)();

document.addEventListener('visibilitychange', () => {
   if (!document.hidden && audioContext.state === 'interrupted') {
      audioContext.resume();
   }
});

if (process.env.NODE_ENV === 'development') {
   window.audioContext = audioContext;
}

const masterTrack = {
   in: audioContext.createGain(),
   gain: audioContext.createGain(),
   limiter: audioContext.createDynamicsCompressor(),
};

masterTrack.in.connect(masterTrack.gain);

// masterTrack.gain.connect(masterTrack.limiter);
// masterTrack.limiter.connect(audioContext.destination);

masterTrack.gain.connect(audioContext.destination);

export { audioContext, masterTrack };
